import { getPanel } from './panel'; //修改处

const getMenuItems = () => {
  const menuItems = {
    items: [getPanel()],
    urlMap: {}
  };

  // Initialize urlMap
  menuItems.urlMap = menuItems.items.reduce((map, item) => {
    item.children.forEach((child) => {
      map[child.url] = child;
    });
    return map;
  }, {});
  return menuItems;
};

export { getMenuItems };
